<div class="wrapper" (panstart)="onDragStart()" (panend)="onDragEnd()" (pan)="onDrag($event)">
  <mat-slide-toggle
    #toggleElement
    (toggleChange)="onChangeEvent()"
    [checked]="checked"
    [disabled]="disabled"
  >
    <ng-content></ng-content>
  </mat-slide-toggle>
</div>
